// extracted by mini-css-extract-plugin
export var deleteModal = "_fk-0";